import 'react';

// simple component to be used as modal root
var MODAL_ROOT = 'sendbird-modal-root';
export { MODAL_ROOT as M };